import request from '@/utils/http.js'

/**
 * @description 用户登录
 * @returns {Promise}
 * @param params
 */
export function login (params) {
  return request.post({
    url: '/user/login',
    params
  })
}

/**
 * @description 用户注册
 * @returns {Promise}
 */
export function parentAddWithUsers (params) {
  return request.post({
    url: '/parent/addWithUsers',
    params
  })
}
/**
 * @description 创建会话
 * @returns {Promise}
 */
export function context (params) {
  return request.post({
    url: '/context',
    params
  })
}

/**
 * @description AI对话
 * @param {Object} params 请求参数
 * @param {Function} onMessage 消息回调函数
 * @param {Object} config 请求配置
 * @returns {Promise}
 */
export function chat (params, onMessage, config = {}) {
  return request.stream({
    url: '/chat',
    params,
    onMessage,
    config
  })
}

/**
 * @description 获取邮箱验证码
 * @param {Object} params 请求参数
 * @param {string} params.email 邮箱地址
 * @returns {Promise}
 */
export function getVerificationCode (params) {
  return request.post({
    url: '/user/verificationCode',
    params
  })
}

/**
 * @description 验证邮箱验证码
 * @param {Object} params 请求参数
 * @param {string} params.email 邮箱地址
 * @param {string} params.verificationCode 验证码
 * @returns {Promise}
 */
export function verifyEmail (params) {
  return request.post({
    url: '/user/verification',
    params
  })
}

/**
 * @description 验证邮箱验证码
 */
export function existAccount (params) {
  return request.post({
    url: '/user/existAccount',
    params
  })
}
/**
 * @description 根据家长id查询学生信息
 */
export function findChild (params) {
  return request.post({
    url: '/parent/findChild',
    params
  })
}
/**
 * @description 根据家长id查询学生信息
 */
export function findById (params) {
  return request.post({
    url: '/user/findById',
    params
  })
}
/**
 * @description 根据家长id查询学生信息
 */
export function edit (params) {
  return request.post({
    url: '/user/edit',
    params
  })
}

/**
 * @description 修改登录账号与密码
 * @param {Object} params
 * @param {number} params.id 用户ID
 * @param {string} params.role 用户角色
 * @param {string} params.userAccount 新账号
 * @param {string} params.password 新密码（AES加密）
 * @returns {Promise}
 */
export function changeCredentials (params) {
  return request.post({
    url: '/user/changeCredentials',
    params
  })
}

/**
 * @description 发送重置密码邮箱验证码
 * @param {Object} params
 * @param {string} params.userAccount 用户账号
 * @returns {Promise}
 */
export function sendResetPasswordCode (params) {
  return request.post({
    url: '/user/resetPasswordCode',
    params
  })
}

/**
 * @description 通过邮箱验证码重置密码
 * @param {Object} params
 * @param {string} params.userAccount 用户账号
 * @param {string} params.verificationCode 邮箱验证码
 * @param {string} params.password 新密码（AES加密）
 * @returns {Promise}
 */
export function resetPassword (params) {
  return request.post({
    url: '/user/resetPassword',
    params
  })
}
/**
 * @description 上传图片
 * @param {FormData} formData
 * @returns {Promise}
 */
export function upload (formData) {
  return request.post({
    url: '/upload',
    params: formData,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })
}

/**
 * 获取会话列表
 * @param {string} userId
 * @param {number|string} knowledgePointId
 */
export function getConversationList (userId, knowledgePointId) {
  return request.get({
    url: `/chat/message/user/${userId}`,
    params: knowledgePointId ? { knowledgePointId } : {}
  })
}
/**
 * 获取会话列表
 * @param {string} userId
 */
export function getParentConversationList (userId) {
  return request.get({
    url: `/chat/message/parent/${userId}`
  })
}

/**
 * 获取会话详情
 * @param {string} conversationId
 */
export function getConversationDetail (conversationId) {
  return request.get({
    url: `/chat/message-detail/conversation/${conversationId}`
  })
}
